import React, {useCallback, useEffect, useState} from 'react';
import { useWeb3React } from '@web3-react/core';
import LandRegistration from '../artifacts/src/contracts/LandRegistration.sol/LandRegistration';
import ManagementCompany from '../artifacts/src/contracts/ManagementCompany.sol/ManagementCompany';
import companyLogo from '../assets/DAILogo.svg';
import Spinner from "./Spinner";
import AddDeveloperModal from "./AddDeveloperModal";
import styled from 'styled-components/macro'
import DeleteDeveloperConfirmationModal from "./DeleteDeveloperConfirmationModal";
import UpdateDeveloperModal from "./UpdateDeveloperModal";
import useSortableData from "./UseSortableData";
import {NavLink} from "react-router-dom";

const DashboardPage = styled.div`
    width: 100%;
    font-family: Lato;
    font-style: normal;
`

const SubTitle = styled.div`
    position: absolute;
    width: 296px;
    height: 25px;
    left: 10%;
    top: 116px;
    padding: 0px;

    font-weight: bold;
    font-size: 14px;
    line-height: 180%;
    color: #000000;
    
    opacity: 0.4;
`

const Title = styled.div`
    position: absolute;
    width: 294px;
    height: 54px;
    left: 10%;
    top: 168px;

    font-weight: bold;
    font-size: 30px;
    line-height: 180%;
    /* identical to box height, or 54px */

    text-transform: capitalize;

    color: #000000;
`

const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    justify-content: center;
    z-index: 1;

    width: 80%;
    margin-left: 10%;
    margin-top: 188px;
`

const TableContainer = styled.div`
    width: 100%;
    min-height: 60vh;
`

const StyledTable = styled.table`
  border: none;
  border-collapse: separate;
  border-spacing: 0px 20px;
  width: 100%;
  font-weight: bold;

  thead {
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    line-height: 180%;
    text-decoration: underline;
  }
    
  td, th {
    border: none;
    width: 20%;
    text-align: left;
    padding-left: 20px;
  }

  td {
    text-align: left;
  }

  tbody tr {
    width: 100%;
    height: 66px;
    
    vertical-align: middle;
    
    background: #FFFFFF;
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
 
    :hover {
      background-color: #f5f5f5;
    }
  }
  
`;

const NavLinkText = styled.div`
      display: inline;
      font-size: 20px;
      margin-left: 20px;
      vertical-align: 50%;
`

const StyledNavLink = styled(NavLink)`
    border: none;
    background: transparent;
    color: black;

    text-decoration: none;

    cursor: pointer;
    
    :hover {
        
    }
`

const HeaderColumn = styled.button`
    font-weight: bold;
    font-size: 20px;
    border: none;
    background: transparent;
    text-decoration: underline;
    
    cursor: pointer;
`

//TODO: WHY IS DEVELOPER LOAN LIMIT HAVE A HARD CODED CURRENCY BASE?
const CURRENCYBASE = 10 ** 18;

const DeveloperDashboardPage = () => {
    const web3Context = useWeb3React();
    const [loading, setLoading] = useState(true);
    const [landRegistrationSC, setLandRegistrationSC] = useState({
        address: process.env.REACT_APP_LANDREGISTRATION_ADDRESS,
        abi: LandRegistration.abi
    });
    const [activeDevelopers, setActiveDevelopers] = useState({
        activeDeveloperIDs: [],
        activeDeveloperInfos: [],
    });

    const { items, requestSort, sortConfig } = useSortableData(activeDevelopers.activeDeveloperInfos);

    const addNewDeveloper = useCallback(async (companyName, location, note) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        await landRegistrationContract.methods
            .addNewDeveloper(companyName.toString(), location.toString(), note.toString())
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const updateDeveloper = useCallback(async (developerId, companyName, location, note) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        await landRegistrationContract.methods
            .updateDeveloper(developerId, companyName.toString(), location.toString(), note.toString())
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const deleteDeveloper = useCallback(async (developerId) => {
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );

        await landRegistrationContract.methods
            .deleteDeveloper(developerId)
            .send({from: web3Context.account})
            .once('receipt', async() => {
                window.location.reload();
            });
    }, [landRegistrationSC, web3Context]);

    const getActiveDevelopers = useCallback(async() => {

        let activeDeveloperIDs = [];
        let activeDeveloperInfos = [];
        const ethLibrary = web3Context.library.eth;
        const landRegistrationContract = new ethLibrary.Contract(
            landRegistrationSC.abi,
            landRegistrationSC.address
        );
        activeDeveloperIDs = await landRegistrationContract.methods
            .getActiveDeveloperIDs()
            .call();
        const totalActiveDeveloperID = activeDeveloperIDs.length;
        let newDeveloperArray = [];
        let newDeveloperObject = {};
        // load developer info by each ID

        for(var i = 1; i < totalActiveDeveloperID; i++) {
            newDeveloperArray = await landRegistrationContract.methods.getDeveloperByID(activeDeveloperIDs[i]).call();
            newDeveloperObject = {
                developerID: activeDeveloperIDs[i],
                companyName: newDeveloperArray[0],
                location: newDeveloperArray[1],
                note: newDeveloperArray[2],
                // uint    developerID;
                loanLimit: newDeveloperArray[4],
                loanBalance: newDeveloperArray[5]
            }
            activeDeveloperInfos.push(newDeveloperObject);
        }

        setActiveDevelopers({activeDeveloperIDs, activeDeveloperInfos});
    }, [landRegistrationSC, web3Context]);

    const loadSCAddress = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const MCAdminContract = new ethLibrary.Contract(
            ManagementCompany.abi,
            process.env.REACT_APP_MCADMIN_ADDRESS
        );

        const LRSC = await MCAdminContract.methods.LRSCAddress().call();

        setLandRegistrationSC({
            address: LRSC,
            abi: LandRegistration.abi
        });

    }, [web3Context]);

    useEffect(() => {
        if(web3Context.active) {
            loadSCAddress();
            getActiveDevelopers();
            setLoading(false);
        }
    },[web3Context]);

    return (
        <DashboardPage>
            <SubTitle>Developer > Manage Developer</SubTitle>
            <Title>Developer List</Title>
            <AddDeveloperModal action={addNewDeveloper} key={"addDeveloper"}/>
            <FlexContainer>
                <TableContainer>
                    <StyledTable>
                        <thead>
                        <tr>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('companyName')}>Developer
                                    <span>{sortConfig !== null && sortConfig.key === 'companyName' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('location')}>Location
                                    <span>{sortConfig !== null && sortConfig.key === 'location' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('loanLimit')}>Loan Limit
                                    <span>{sortConfig !== null && sortConfig.key === 'loanLimit' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('loanBalance')}>Loan Balance
                                    <span>{sortConfig !== null && sortConfig.key === 'loanBalance' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                Action
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading ? (<Spinner/>) : items.map((developer, index) => {
                            return (
                                <tr key={index}>
                                    <td><StyledNavLink to={'/developer/' + developer.developerID}><img src={companyLogo} style={{width: "40px"}}/><NavLinkText>{developer.companyName}</NavLinkText></StyledNavLink></td>
                                    <td><StyledNavLink to={'/developer/' + developer.developerID}>{developer.location}</StyledNavLink></td>
                                    <td><StyledNavLink to={'/developer/' + developer.developerID}>${developer.loanLimit}</StyledNavLink></td>
                                    <td><StyledNavLink to={'/developer/' + developer.developerID}>${developer.loanBalance}</StyledNavLink></td>
                                    <td>
                                        <UpdateDeveloperModal
                                            developerId={developer.developerID}
                                            companyName={developer.companyName}
                                            location={developer.location}
                                            note={developer.note}
                                            action={updateDeveloper}
                                        />
                                        <DeleteDeveloperConfirmationModal
                                            developerId={developer.developerID}
                                            header={"Delete Developer " + developer.companyName + "?"}
                                            message={'Are you sure that you want to delete developer "' + developer.companyName + '"?'}
                                            note={"Note: You must remove the land associated with the developer before the developer can be deleted."}
                                            actionLabel = {"Delete Developer"}
                                            action={deleteDeveloper}/>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </StyledTable>
                </TableContainer>
            </FlexContainer>
        </DashboardPage>);
};

export default DeveloperDashboardPage;
